import {
  LOGINUSER,
  GET_DOCTORS,
  GET_OPTICIANS,
  GET_PATIENTS,
  DELETE_DOCTOR,
  DELETE_PATIENT,
  DELETE_OPTICIAN,
  UPDATEOPTICIANROLE,
  GET_NEW_USERS,
  VERIFY_LICENSE,
  DELETE_NEW_USER,
  GET_ACTIVE_USERS,
  GET_DEACTIVE_USERS,
  UPDATE_DEACTIVE_USERS,
  CREATE_USER,
  PERMANENT_DELETE_USER,
} from "../type";

const initial = {
  loginUser: [],
  doctors: [],
  opticians: [],
  patinets: [],
  deletedoctor: [],
  deletepatient: [],
  deleteoptician: [],
  deletenewuser: [],
  updateoptician: [],
  verifylicense: [],
  newusers: [],
  activeusers: [],
  deactiveusers: [],
  updateDeactiveUsers: [],
  createuser: [],
  permanentDeleteUser: [],
  error: null, // أضف حقل للخطأ
  loading: true,
};

const userReducer = (state = initial, action) => {
  switch (action.type) {
    case LOGINUSER:
      return {
        ...state,
        loginUser: action.payload,
        loading: false,
      };
    case GET_DOCTORS:
      return {
        ...state,
        doctors: action.payload,
        loading: false,
      };

    case GET_OPTICIANS:
      return {
        ...state,
        opticians: action.payload,
        loading: false,
      };
    case GET_NEW_USERS:
      return {
        ...state,
        newusers: action.payload,
        loading: false,
      };
    case PERMANENT_DELETE_USER:
      return {
        ...state,
        permanentDeleteUser: action.payload,
      };

    case GET_PATIENTS:
      return {
        ...state,
        patients: action.payload,
        loading: false,
      };
    case VERIFY_LICENSE:
      return {
        ...state,
        verifylicense: action.payload,
      };
    case GET_ACTIVE_USERS:
      return {
        ...state,
        activeusers: action.payload,
        loading: false,
      };
    case GET_DEACTIVE_USERS:
      return {
        ...state,
        deactiveusers: action.payload,
        loading: false,
      };
    case DELETE_DOCTOR:
      return {
        ...state,
        deletedoctor: action.payload,
      };
    case DELETE_PATIENT:
      return {
        ...state,
        deletepatient: action.payload,
      };
    case DELETE_NEW_USER:
      return {
        ...state,
        deletenewuser: action.payload,
      };
    case DELETE_OPTICIAN:
      return {
        ...state,
        deleteoptician: action.payload,
      };
    case UPDATEOPTICIANROLE:
      return {
        ...state,
        updateoptician: action.payload,
      };
    case UPDATE_DEACTIVE_USERS:
      return {
        ...state,
        updateDeactiveUsers: action.payload,
      };
    case CREATE_USER:
      return {
        ...state,
        createuser: action.payload,
      };

    default:
      return state;
  }
};
export default userReducer;
